import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { customerSupportDataSelector } from 'redux/selectors';
import { useSearchParams } from 'react-router-dom';

export default function useApplyFiltersModal({ applyFilters, setOpen, open }) {
  //state for react router search params
  const [searchParams, setSearchParams] = useSearchParams();

  //support data for select field options
  const supportData = useSelector(customerSupportDataSelector);

  //state for sales rep field
  const [salesRep, setSalesRep] = useState([]);

  //state for price group field
  const [priceGroup, setPriceGroup] = useState([]);

  //state for payment terms field
  const [paymentTerms, setPaymentTerms] = useState([]);

  //state for shipping method field
  const [shippingMethod, setShippingMethod] = useState([]);

  //state for groups field
  const [groups, setGroups] = useState([]);

  //state for sort by field
  const [sortBy, setSortBy] = useState('');

  //state for show retailers field
  const [showRetailersAndBuyersWith, setShowRetailersAndBuyersWith] =
    useState('');

  // state for buyers field
  const [showBuyers, setShowBuyers] = useState([]);

  //state for currency field
  const [currency, setCurrency] = useState([]);

  /******************************************************************************************
   * set initial field values
   ******************************************************************************************/
  async function initializeForm() {
    //get filters object from url search params
    let filtersObject =
      searchParams.get('filters') !== ''
        ? JSON.parse(searchParams.get('filters'))
        : null;

    //initialize fields
    setSalesRep(filtersObject?.salesRep ?? []);
    setPriceGroup(filtersObject?.priceGroup ?? []);
    setPaymentTerms(filtersObject?.paymentTerms ?? []);
    setShippingMethod(filtersObject?.shippingMethod ?? []);
    setGroups(filtersObject?.groups ?? []);
    setSortBy(filtersObject?.sortBy ?? '');
    setShowRetailersAndBuyersWith(
      filtersObject?.showRetailersAndBuyersWith ?? ''
    );
    setShowBuyers(filtersObject?.showBuyers ?? []);

    //set filters count
  }

  /******************************************************************************************
   * apply or reset filters
   ******************************************************************************************/
  function handleSubmit({ action }) {
    //check if the specific filter is applied
    let obj = {};
    if (salesRep?.length > 0) obj.salesRep = salesRep;
    if (priceGroup?.length > 0) obj.priceGroup = priceGroup;
    if (paymentTerms?.length > 0) obj.paymentTerms = paymentTerms;
    if (shippingMethod?.length > 0) obj.shippingMethod = shippingMethod;
    if (groups?.length > 0) obj.groups = groups;
    if (sortBy) obj.sortBy = sortBy;
    if (showRetailersAndBuyersWith)
      obj.showRetailersAndBuyersWith = showRetailersAndBuyersWith;
    if (showBuyers?.length > 0) obj.showBuyers = showBuyers;

    //calculate filters count
    let filtersCount = 0;
    filtersCount += salesRep?.length ?? 0;
    filtersCount += priceGroup?.length ?? 0;
    filtersCount += paymentTerms?.length ?? 0;
    filtersCount += shippingMethod?.length ?? 0;
    filtersCount += showRetailersAndBuyersWith ? 1 : 0;
    filtersCount += sortBy ? 1 : 0;
    filtersCount += currency?.length ?? 0;
    filtersCount += showBuyers?.length ?? 0;

    //apply filters
    if (action === 'apply') {
      applyFilters(JSON.stringify(obj), filtersCount);
    }

    //reset filters
    else if (action === 'reset') {
      applyFilters('', 0);
    }

    setOpen(false);
  }

  /******************************************************************************************
   * effects
   ******************************************************************************************/

  //initialize form after supportData and searchParams loads
  useEffect(() => {
    initializeForm();
  }, [searchParams, open]);

  return {
    salesRep,
    setSalesRep,

    priceGroup,
    setPriceGroup,

    paymentTerms,
    setPaymentTerms,

    shippingMethod,
    setShippingMethod,

    sortBy,
    setSortBy,

    showRetailersAndBuyersWith,
    setShowRetailersAndBuyersWith,

    groups,
    setGroups,

    currency,
    setCurrency,

    showBuyers,
    setShowBuyers,

    handleSubmit,
    supportData,
  };
}
